import { UserApi, usersApi } from "api/users/usersApi";
import { IDropdownOption } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useUsers = (skip: number, limit: number, filter: string = "", orderBy: string = "") => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.USERS(skip, limit, filter, orderBy),
    queryFn: () => usersApi.fetch(skip, limit, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.USERS(skip, limit, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, users: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export interface UserOption extends IDropdownOption {
  user?: UserApi;
}
export const useUsersOptions = () => {
  const { isLoading, users } = useUsers(0, 1_000_000);

  const options: UserOption[] = users.map((x) => ({
    value: x.id,
    label: x.firstName + " " + x.surname,
    user: x,
  }));

  return { isLoading, options };
};
